module.exports = __webpack_public_path__ + "img/asset9x1.0ce2ee5b.png";